module.exports = function getResource(label, vars = []) {
    let resources = {
        add: 'Ajouter',
        new: 'Nouveauté'
    };
    return resources[label];
};
